import { defaultRegionInfoProvider } from "./endpoints";
import { parseUrl } from "@aws-sdk/url-parser";
/**
 * @internal
 */
export var getRuntimeConfig = function (config) {
    var _a, _b, _c, _d, _e;
    if (config === void 0) { config = {}; }
    return ({
        apiVersion: "2021-05-15",
        disableHostPrefix: (_a = config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config.regionInfoProvider) !== null && _c !== void 0 ? _c : defaultRegionInfoProvider,
        serviceId: (_d = config.serviceId) !== null && _d !== void 0 ? _d : "Chime SDK Messaging",
        urlParser: (_e = config.urlParser) !== null && _e !== void 0 ? _e : parseUrl,
    });
};
//# sourceMappingURL=runtimeConfig.shared.js.map